import { hideToast, showToast } from '../store/modules/toast';
import _ from 'lodash';

const TOAST_REMAIN_TIME = 3000;
const timer = _.debounce((store) => {
  store.dispatch(hideToast());
}, TOAST_REMAIN_TIME);

export const toastTimer = (store) => (next) => (action) => {
  if (action.type === showToast.type) {
    timer(store);
  }
  return next(action);
};
